import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  styles: [
    `
      .file-group {
        /* MDC: Feld und Loeschen-Button auf einer Linie zentrieren */
        align-items: center;
        padding: 8px 16px;
      }

      .file-group button {
        min-width: 48px;
      }
    `,
  ],
  template: `
    @for (field of field.fieldGroup; track field; let i = $index) {
      <mat-card appearance="outlined" class="mat-elevation-z8 file-group d-flex flex-row gap-10">
        <formly-field [field]="field" class="flex-1"></formly-field>
        <div class="flex-initial d-flex justify-end items-start">
          <button mat-raised-button color="warn" type="button" (click)="remove(i)">
            <!-- [style.margin-top.px]="16" -->
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </mat-card>
    }
    <div style="margin:20px 0;" class="d-flex flex-row gap-20">
      <button
        mat-raised-button
        color="accent"
        type="button"
        (click)="add()"
        #tooltip="matTooltip"
        [matTooltip]="field.templateOptions?.tooltip"
        [disabled]="!(!to.maxItems || to.maxItems > field.fieldGroup!.length)"
      >
        <mat-icon>add </mat-icon>{{ to.addText }}
      </button>

      @if (field.templateOptions?.tooltip) {
        <button mat-button color="accent" type="button" (click)="tooltip.toggle()">
          <mat-icon>help_outline</mat-icon>
        </button>
      }
      @if (!(!to.maxItems || to.maxItems > field.fieldGroup!.length)) {
        <p
          color="warn"
          [innerText]="'ticket.create.p__error_max_attachments' | translate: { max: to.maxItems }"
        ></p>
      }
    </div>
  `,
  standalone: false,
})
export class RepeatTypeComponent extends FieldArrayType {}
